import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";

const TX = { pt: { eyebrow: "Opiniões de clientes", from: "Cliente GoldenTime" }, en: { eyebrow: "Client reviews", from: "GoldenTime client" } };

export function WatchReviews({ slug, lang }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/public/reviews/watch/${slug}`).then((x) => setItems(x.data)).catch(() => setItems([])); }, [slug]);
  if (!items.length) return null;
  const L = TX[lang === "en" ? "en" : "pt"];
  return (
    <section className="mt-24 border-t border-[#282520] pt-12" data-testid="watch-reviews">
      <p className="eyebrow">{L.eyebrow}</p>
      <div className="mt-8 grid md:grid-cols-2 gap-8">
        {items.map((v) => (
          <figure key={v.id} className="bg-[#161512] border border-[#282520] p-6 sm:p-8 flex gap-6" data-testid={`watch-review-${v.id}`}>
            {v.photo?.sm && <img src={mediaUrl(v.photo.md || v.photo.sm)} alt="" loading="lazy" className="w-28 h-36 object-cover shrink-0" />}
            <div>
              <div className="flex gap-1">{[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`w-4 h-4 ${n <= v.stars ? "fill-[#C8AE6E] text-[#C8AE6E]" : "text-[#5a554c]"}`} strokeWidth={1.2} />)}</div>
              <blockquote className="mt-4 text-[#F3EFE6]/90 text-sm leading-relaxed space-y-2">{[v.experience, v.quality, v.comment].filter(Boolean).map((p, i) => <p key={i}>“{p}”</p>)}</blockquote>
              <figcaption className="mt-4 text-[11px] uppercase tracking-[0.2em] text-[#A39E93]">{v.first_name} · {L.from}</figcaption>
            </div>
          </figure>
        ))}
      </div>
    </section>
  );
}
